import {
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/constructionSop/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSop/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSop/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSop/img/4.avif';
import image5 from '@src/assets/images/solution/constructionSop/img/5.avif';
import image6 from '@src/assets/images/solution/constructionSop/img/6.avif';
import image7 from '@src/assets/images/solution/constructionSop/img/7.avif';
import image8 from '@src/assets/images/solution/constructionSop/img/8.avif';

export default {
  type: '建設ソリューション',

  banner: {
    title: '危険自動検知と対応',
    desc: 'SOPに基づき現場の危険状況をリアルタイムで検知し自動対応します。すべての履歴はデータとして保存され、監査や報告の証拠資料として活用できます。デジタル技術で安全管理を効率化し、事故を未然に防ぎます。',
  },

  video: {
    title: '標準化された手順で事故を自動検知し迅速に対応',
    desc: '作業者の動線と危険要素をリアルタイムで検知し、SOPに基づいて自動アラーム・記録・対応まで連携します。データは自動保存され、後の分析や監査に役立ちます。',
    play: mainVideo,
  },

  func: [
    {
      theme: '危険自動検知とリアルタイム対応',
      title: 'SOP基盤の自動危険認識',
      desc: '作業者の動きと周辺環境を分析し、SOPから外れた作業を自動で検知し、AIで異常兆候も判断します。',
      sub1: '高精度提供',
      icon1: IconRulerGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '危険検知時のSOP対応パネル自動呼び出し',
      desc: '危険イベントが発生すると、該当作業に適したSOP対応手順が自動でポップアップします。対応者はワンクリックで手順を開始でき、ゴールデンタイムを確保できます。',
      sub1: '高速データ連携',
      icon1: IconTvocGray,
      sub2: 'リアルタイム位置追跡',
      icon2: IconBinocularsGray,
      image: image2,
    },
    {
      title: 'CCTV確認と閲覧履歴の自動保存',
      desc: '危険発生エリアのCCTVを自動呼び出し、閲覧した映像と時間をすべて自動で記録します。後の事故調査や法的証拠資料としてすぐに活用可能です。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高精度提供',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: 'モバイルベースのSOP対応参加支援',
      desc: 'PCがなくてもスマートフォンでSOP手順に参加でき、外部管理者や移動中の責任者もリアルタイムで対応できます。緊急時も場所を問わず対処が可能です。',
      sub1: '自由な範囲設定',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image4,
    },
    {
      theme: 'SOP運用とカスタマイズ管理',
      title: 'SOP別対応状況の可視化',
      desc: '進行中のSOPシナリオごとに現在のステップと完了状況をダッシュボードに表示し、全体の対応状況を一目で把握できます。管理者は優先度に応じて追加の人員やリソースを配置できます。',
      sub1: '自由な範囲設定',
      icon1: IconTagGray,
      sub2: '複数エリア設定',
      icon2: IconZoneGray,
      image: image5,
    },
    {
      title: 'レポート自動生成とダウンロード',
      desc: '対応履歴、アラーム発生時間、対応完了状況などの主要データを基に自動でレポートを作成し、PDFやExcel形式でダウンロード可能です。週次・月次レポート作成の時間と人手を削減します。',
      sub1: '高精度提供',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image6,
    },
    {
      title: '条件ベースのアラームシナリオ生成',
      desc: '温度、ガス、位置、動作状態などの条件を組み合わせてカスタムアラームルールを作成できます。これにより、様々なIoTセンサーと連携した自動危険検知トリガーを設定可能です。',
      sub1: '迅速な設置完了',
      icon1: IconTagGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image7,
    },
    {
      title: 'SOPシナリオ編集と現場カスタマイズ',
      desc: '現場の特性や作業タイプに応じてSOPのステップを編集または新規作成できます。GUIベースのインターフェースで誰でも簡単に手順を追加・削除し、現場に適用可能です。',
      sub1: 'リアルタイム可視化',
      icon1: IconShareGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image8,
    },
  ],

  subfunc: {
    title: '多様な機能',
    desc: '作業者の安全を確保することで、効率を高め、事故による損失を減らします。ORBROは建設現場の作業者を守るために最適な機能を構成しています。作業者が危険エリアに接近したり事故が発生した場合、または重機が持つ潜在的なリスク状況にも適切に対応できるシステムを構築しました。',

    data: [
      { icon: IconWarning, title: 'リアルタイム危険検知', desc: '作業者・センサーで即検知し通知。' },
      { icon: IconBell, title: 'SOP自動実行', desc: '危険発生時、SOPを自動呼出。' },
      { icon: IconDashboard, title: '統合モニタリング', desc: '安全データを一目で確認可能。' },
      { icon: IconBell, title: '異常通知自動送信', desc: 'SMS・メールで自動通知。' },
      { icon: IconRoute, title: 'CCTV自動連動', desc: 'イベント時にCCTV自動表示。' },
      { icon: IconSearch, title: 'モバイル対応', desc: 'スマホでSOP操作・即対応。' },
      { icon: IconChartRadius, title: '進捗リアル表示', desc: 'SOP進捗をリアルタイム把握。' },
      { icon: IconChainLink, title: '検知条件設定', desc: '条件を組み合わせて設定可。' },
      { icon: IconChartRadius, title: '自動レポート作成', desc: '履歴でPDF・Excel生成可。' },
      { icon: IconSecurity, title: '監査証跡対応', desc: '履歴を自動保存し監査対応。' },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
